import React from 'react'
import Svg from './Svg'
export const SvgInspections = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M7.118 4.821a4.794 4.794 0 119.589 0 4.794 4.794 0 11-9.589 0zm11.189 6.393h-.884L12.45 21.309l1.86-9.296-2.397-2.397-2.398 2.397 1.86 9.296-4.972-10.095h-.885c-3.195 0-3.195 2.147-3.195 4.795V24h19.179v-7.991c0-2.648 0-4.795-3.195-4.795z" />
  </Svg>
))
SvgInspections.isIcon = true
export default SvgInspections
